/**
 * File nav-menu.js.
 * Handles logic for navigation menu including submenus
 * Handles sticky navigation logic
 * Handles disabling footer menu category names
 */

function navMenuInit($) {
  const navButtons = $('.header__nav-btn');
  const closeButton = $('.header__nav-btn--close');
  const openButton = $('.header__nav-btn--open');
  const navContainer = $('.header__nav-menu-container');
  const header = $('#header');
  const menuLinkSubnav = $('#primary-menu li.menu-item-has-children');
  const disabledLink = $('.footer__nav-menu .menu-item-has-children > a');
  const bodyHtml = $('body, html');
  const headerThemeSwitchOffset = 10;
  
  function toggleAriaExpanded(expanded) {
    navButtons.each(function () {
      $(this).attr('aria-expanded', expanded);
    });
  }

  function openNav() {
    navContainer.removeClass('header__nav-menu-container--closed')
      .addClass('header__nav-menu-container--opened');
    bodyHtml.css('overflow', 'hidden');
    toggleAriaExpanded('true');
    // Need a slight timeout to let the item come back into visibility
    setTimeout(function () { closeButton.focus() }, 100);
  }

  function closeNav() {
    navContainer.removeClass('header__nav-menu-container--opened')
      .addClass('header__nav-menu-container--closed');
    bodyHtml.css('overflow', 'visible');
    toggleAriaExpanded('false');
    openButton.focus();
  }

  function setStickyNav() {
    var scrollPositionY = $(document).scrollTop();
    if (scrollPositionY > headerThemeSwitchOffset) {
      header.addClass('header--is-scrolled');
      if (header.hasClass('header--light')) {
        header.removeClass('header--light')
          .addClass('header--was-light');
      }
      $(window).off('scroll', setStickyNav)
        .on('scroll', unsetStickyNav);
    }
  }

  function unsetStickyNav() {
    var scrollPositionY = $(document).scrollTop();
    if (scrollPositionY < headerThemeSwitchOffset) {
      header.removeClass('header--is-scrolled');
      if (header.hasClass('header--was-light')) {
        header.removeClass('header--was-light')
          .addClass('header--light');
      }
      $(window).off('scroll', unsetStickyNav)
        .on('scroll', setStickyNav);
    }
  }

  // Show submenus when hover Menu items, add scrolled class to header to give it background
  function showSubmenu(element) {
    element.find('.sub-menu').addClass('sub-menu--show');
  }

  // Hide submenu when mouse leaves header, remove scrolled class if at top of window
  function hideSubmenu() {
    $('.sub-menu').removeClass('sub-menu--show');
  }

  // Inits
  $(window).on("load", setStickyNav)
    .on("scroll", setStickyNav);

  openButton.on('click', openNav);
  closeButton.on('click', closeNav);

  menuLinkSubnav.on('mouseenter focusin', function () { showSubmenu($(this)) })
    .on('mouseleave focusout', function () { hideSubmenu($(this)) });
  header.on('mouseleave', hideSubmenu);

  disabledLink.on('click', function (event) { event.preventDefault(); });
}